import { Box, Button, FormControl, FormErrorMessage, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";
import OcurrenceTable from "./components/Table";

import useOcurrence from "./hooks/useOccurence";

export default function Occurrence() {
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  const {
    OccurenceTypeList,
    add,
    edit,
    loading,
    show,
    showModal,
    accountSelected,
    nomeRef,
    error,
    save,
    showDelete,
    showDeleteModal,
    cancelRef,
    closeDelete,
    deletar,
  } = useOcurrence();
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
    <SimpleGrid
      mb="20px"
      columns={{ sm: 1, md: 1 }}
      spacing={{ base: "20px", xl: "20px" }}
    >
      <OcurrenceTable
        add={add}
        edit={edit}
        list={OccurenceTypeList}
        deletar={showDeleteModal}
        showDelete={showDelete}
        cancelRef={cancelRef}
        closeDelete={closeDelete}
        remove={deletar}
      />

      <Modal
        onClose={() => {
          showModal(false);
        }}
        size={"2xl"}
        isOpen={show}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {accountSelected !== null
              ? "Editar Categoria"
              : "Nova Categoria"}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isInvalid={error}>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nome<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                // ref={nomeRef}
                defaultValue={accountSelected?.nome}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Preencha o nome da Categoria"
                onChange={(e) => (nomeRef.current = e.target.value)}
                mb="24px"
                fontWeight="500"
                isInvalid={error}
                size="lg"
              />
              {error && (
                <FormErrorMessage>
                  Preencha Corretamente o Campo.
                </FormErrorMessage>
              )}
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={() => {
                showModal(false);
              }}
              variant="outline"
              marginRight={4}
            >
              Fechar
            </Button>
            <Button
              onClick={() => {
                save();
              }}
              colorScheme="brand"
              isLoading={loading}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </SimpleGrid>
  </Box>
  )
}
